export function moveSet(ev: KeyboardEvent): void {
    const target = ev.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    const groupContent = target.closest(".settingsBubbleContent");

    if (!(groupContent instanceof HTMLElement) || groupContent.parentElement === null) {
        return;
    }

    const allSetItems = Array.from(groupContent.querySelectorAll(".settingItem"));
    const groupWidth = groupContent.clientWidth;
    const targetWidth = target.clientWidth;
    const targetIndex = allSetItems.indexOf(target);
    const itemsPerRow = Math.floor(groupWidth / targetWidth);

    let targetElement: Element | null = null;

    if (ev.key === "ArrowRight") {
        targetElement = allSetItems[targetIndex + 1];
    } else if (ev.key === "ArrowLeft") {
        targetElement = allSetItems[targetIndex - 1];
    } else if (ev.key === "ArrowUp") {
        targetElement = allSetItems[Math.max(0, targetIndex - itemsPerRow)];
    } else if (ev.key === "ArrowDown") {
        targetElement = allSetItems[Math.max(0, targetIndex + itemsPerRow)];
    }

    if (targetElement instanceof HTMLElement) {
        ev.preventDefault();
        targetElement.focus();
    }
}
